import { string, object } from 'prop-types';

const AndesMessageInterventionPropTypes = {
  intervention: object.isRequired,
  other_sellers_text: string,
  query: string,
  zrp_query_text: string.isRequired,
  disclaimerClassName: string.isRequired,
  messageClassName: string.isRequired,
};

export { AndesMessageInterventionPropTypes };
